var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileSubmit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.129 20.257L20.203.061.007 8.135l4.707 4.721 11.448-8.755L7.408 15.55l4.72 4.707z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjEyODYgMjAuMjU3MkwyMC4yMDMxIDAuMDYwODY5NEwwLjAwNjczNDM0IDguMTM1MzZMNC43MTQwNCAxMi44NTYxTDE2LjE2MjQgNC4xMDE0OEw3LjQwNzc4IDE1LjU0OTlMMTIuMTI4NiAyMC4yNTcyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgMobileSubmit as ReactComponent };